import { render, staticRenderFns } from "./SyncHistories.vue?vue&type=template&id=a90c9b60"
import script from "./SyncHistories.vue?vue&type=script&lang=js"
export * from "./SyncHistories.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports